<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

let xLabel = [
  "2023年5月",
  "2023年11月",
  "2024年5月",
  "2024年11月",
  "2025年5月",
  "2025年11月",
  "2026年2月"
];
let dataValue = [530.84, 605.94, 452.85, 457.35, 441.43, 446.15, 407.43];

const option = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      lineStyle: {
        color: "rgb(126,199,255)",
      },
    },
  },
  legend: {
    show: true,
    top: "10%",
    itemWidth: 30, // 图例标记的图形宽度。
    //   itemGap: 20, // 图例每项之间的间隔。
    itemHeight: 10, //  图例标记的图形高度。
    textStyle: {
      color: "#fff",
      fontSize: 14,
      padding: [0, 8, 0, 8],
    },
  },
  title: {
    text: "单位：元/斤",
    // subtext: "13000吨",

    textStyle: {
      color: "#f2f2f2",
      fontSize: 30,
    },
    subtextStyle: {
      fontSize: 30,

      color: ["#ff9d19"],
    },

    x: "5%",
    y: "5%",
  },
  grid: {
    top: "18%",
    left: "10%",
    right: "5%",
    bottom: "20%",
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      axisLine: {
        //坐标轴轴线相关设置。数学上的x轴
        show: true,
        lineStyle: {
          color: "rgb(41,188,245)",
        },
      },
      axisLabel: {
        //坐标轴刻度标签的相关设置
        textStyle: {
          color: "#FFFFFF",
          fontSize: 26,
        },
        interval: 0,
        formatter: function (params) {
          var str = ""; // 最终拼接成的字符串
          var paramsLen = params.length; // 获取每项文字的个数
          var len = 5; // 每行能显示的字的个数（根据实际情况自己设置）
          var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
          if (paramsLen > len) {
            //大于设定的len就换行，不大于就不变化
            for (var i = 0; i < rowNumber; i++) {
              var temp = ""; // 表示每一次截取的字符串
              var start = i * len; // 开始截取的位置
              var end = start + len; // 结束截取的位置
              if (i == rowNumber - 1) {
                // 最后一次不换行
                temp = params.substring(start, paramsLen);
              } else {
                // 每一次拼接字符串并换行
                temp = params.substring(start, end) + "\n";
              }
              str += temp; // 最终拼成的字符串
            }
          } else {
            // 给新的字符串赋值
            str = params;
          }
          return str; //返回字符串
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#233653",
        },
      },
      axisTick: {
        show: false,
      },
      data: xLabel,
    },
  ],
  yAxis: [
    {
      name: "",
      nameTextStyle: {
        color: "#fff",
        fontSize: 26,
        padding: [0, 60, 0, 0],
      },
      // minInterval: 1,
      type: "value",
      splitLine: {
        show: true,
        lineStyle: {
          color: "#1160a0",
          type: "dashed",
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#008de7",
        },
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#fff",
          fontSize: 26,
        },
      },
      axisTick: {
        show: false,
      },
    },
  ],
  series: [
    {
      name: "",
      type: "line",
      symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
      smooth: true,
      lineStyle: {
        normal: {
          width: 3,
          color: "#ffba00", // 线条颜色
        },
      },
      itemStyle: {
        normal: {
          color: "#fff600", //拐点颜色
          // borderColor: '#fff600',//拐点边框颜色
          // borderWidth: 13//拐点边框大小
          label: {
            show: false, //开启显示
            color: "#fff",
            position: "top", //在上方显示
            formatter: function (res) {
              if (res.value) {
                return res.value;
              } else {
                return 0;
              }
            },
          },
        },
      },
      symbolSize: 8, //设定实心点的大小
      areaStyle: {
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#ffba0030",
              },
              {
                offset: 0.6,
                color: "#ffba0020",
              },
              {
                offset: 1,
                color: "#ffba0010",
              },
            ],
            false
          ),
        },
      },
      data: dataValue,
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
